WiseMetering.Views.ShowWiseJsonConfiguration = WiseMetering.Views.Modal.Show.extend({
    className: 'mbx-info text-left',
    template: 'templates/integration_configurations/wise_json/show',
    title: () => i18next.t('modal.title.integration_configurations.show')
});
